/* MOS lazy menu (2026-09-03)
 * The header now ships only the top-level menu and the L1 sidebar links. The L2/L3 links
 * (about 550 collection links, ~420KB of HTML) are fetched once, on the first real user
 * interaction, from the header section rendered via the Section Rendering API on
 * /search?q=mos-menu-panels, where the two menu snippets switch to their full output.
 * Crawlers that do not interact never receive them, which stops every page on the site
 * linking to ~650 collections.
 */
(function () {
  'use strict';
  if (window.mosLazyMenuInit) return;
  window.mosLazyMenuInit = true;

  // The header section's instance id, e.g. "sections--28519464501611__header".
  var sectionId = window.mosMenuSectionId;
  if (!sectionId) {
    var hdr = document.querySelector('.shopify-section-header');
    if (hdr && hdr.id) sectionId = hdr.id.replace(/^shopify-section-/, '');
  }
  if (!sectionId) return;

  var url = '/search?q=mos-menu-panels&section_id=' + encodeURIComponent(sectionId);
  var state = 'idle'; // idle | loading | done | failed
  var triggers = ['pointermove', 'pointerdown', 'touchstart', 'keydown', 'focusin'];

  function bindSidebar(panelsEl) {
    var menu = panelsEl.closest('.mega-menu--nav-sidebar');
    if (!menu) return;
    var links = menu.querySelectorAll('.mega-menu-nav-sidebar__sidebar-link');
    var panels = panelsEl.querySelectorAll('.mega-menu-nav-sidebar__panel');
    var activate = function (e) {
      var target = e.currentTarget.getAttribute('data-sidebar-target');
      for (var i = 0; i < panels.length; i++) {
        panels[i].classList.toggle('active', panels[i].id === target);
      }
    };
    for (var j = 0; j < links.length; j++) {
      links[j].addEventListener('mouseenter', activate);
      links[j].addEventListener('focus', activate);
    }
    // Keep whichever L1 is currently highlighted (header.js may have moved it before we loaded).
    var current = menu.querySelector('.mega-menu-nav-sidebar__sidebar-link.active');
    if (current) activate({ currentTarget: current });
  }

  function inject(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var count = 0;

    var desktop = doc.querySelectorAll('[data-mos-panels-for]');
    for (var i = 0; i < desktop.length; i++) {
      var handle = desktop[i].getAttribute('data-mos-panels-for');
      var targets = document.querySelectorAll('.mega-menu-nav-sidebar__panels[data-mos-lazy="' + handle + '"]');
      for (var t = 0; t < targets.length; t++) {
        targets[t].innerHTML = desktop[i].innerHTML;
        bindSidebar(targets[t]);
        count++;
      }
    }

    var mobile = doc.querySelectorAll('[data-mos-mobile-for]');
    for (var m = 0; m < mobile.length; m++) {
      var h = mobile[m].getAttribute('data-mos-mobile-for');
      var shells = document.querySelectorAll('[data-mos-lazy-mobile="' + h + '"]');
      for (var s = 0; s < shells.length; s++) {
        shells[s].innerHTML = mobile[m].innerHTML;
        count++;
      }
    }
    document.documentElement.classList.add('mos-menu-loaded');
    return count;
  }

  function load() {
    if (state !== 'idle') return;
    state = 'loading';
    unbind();
    fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('mos-lazy-menu: HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var n = inject(html);
        state = n > 0 ? 'done' : 'failed';
        if (n === 0) console.warn('mos-lazy-menu: response contained no panels');
      })
      .catch(function (err) {
        state = 'failed';
        console.warn(err);
        showFallback();
      });
  }

  // If the fetch fails, make the top-level and L1 links usable: they are real links already,
  // so just clear the "Loading" placeholders.
  function showFallback() {
    var ph = document.querySelectorAll('.mos-lazy-placeholder');
    for (var i = 0; i < ph.length; i++) ph[i].remove();
  }

  function bind() {
    for (var i = 0; i < triggers.length; i++) {
      window.addEventListener(triggers[i], load, { passive: true, once: true });
    }
  }
  function unbind() {
    for (var i = 0; i < triggers.length; i++) {
      window.removeEventListener(triggers[i], load);
    }
  }

  // Theme editor re-renders the header; re-inject if a shell is present and we already have data.
  document.addEventListener('shopify:section:load', function () {
    if (state === 'done') { state = 'idle'; load(); }
  });

  bind();
})();